import { Dialog, Transition } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import React, { Fragment } from "react";
import LoginButton from "./LoginButton";

const LoginRequiredModal = ({ isOpen, onClose, message, children }) => {
    return (
        <Transition show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left shadow-xl transition-all">
                            <div className="flex items-center space-x-4 mb-4">
                                <ExclamationTriangleIcon className="h-6 w-6 text-yellow-600" />
                                <Dialog.Title className="text-lg font-medium text-gray-900">
                                    Necesitas iniciar sesión
                                </Dialog.Title>
                            </div>

                            <div className="text-gray-700 mb-4">{message}</div>

                            <div className="mb-6 bg-gray-100 rounded-lg p-4">
                                <p className="font-semibold text-gray-800 mb-2">Al registrarte podrás:</p>
                                <ul className="text-sm text-gray-700 space-y-2 pl-4 list-disc">
                                    <li><span className="text-blue-600">⭐</span> Guardar tus propiedades favoritas</li>
                                    <li><span className="text-green-600">📊</span> Acceder a rentabilidades personalizadas</li>
                                    <li><span className="text-purple-600">🔄</span> Comparar escenarios de reforma y alquiler</li>
                                    <li><span className="text-yellow-600">🌅</span> Visualizar costes de alquiler vacacional</li>
                                </ul>
                            </div>

                            <div className="mt-6 flex justify-between items-center gap-4">
                                <div><LoginButton /></div>
                                <button
                                    className="px-4 py-2 bg-gray-700 hover:bg-gray-800 text-white rounded"
                                    onClick={onClose}
                                >
                                    Cerrar
                                </button>
                            </div>

                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
};

export default LoginRequiredModal;